import { graphql } from '@/gql'

export const CreateBatchMutation = graphql(`
  mutation CreateBatch($input: CreateBatchInput!) {
    createBatch(input: $input) {
      id
      name
      type
      processingItemsCount: itemsCountByStatus(status: [PROCESSING])
      processedItemsCount: itemsCountByStatus(status: [PROCESSED])
      items {
        data {
          ... on PaymentRequest {
            id
          }
        }
      }
    }
  }
`)
